import React from 'react'
import No_data_found from "../../assets/images/common/no_data_found.svg";

export const NoDataFound = () => {
    return (
        <div className='d-flex align-item-center flex-column justify-content-center text-center'>
            <div>
                <img src={No_data_found} alt='no_data_img' />
            </div>
            <div  style={{fontSize:'20px',fontWeight:'600',color:'#050505'}}>
                No Data Available
            </div>
            <div style={{color:'#404040'}}>
                We couldn’t find anything matching your filters
            </div>
            <div style={{color:'#0052cc'}}>
                Try again with different options.
            </div>

        </div>
    )
}